import { useCallback } from 'react';

import { useLensPins } from './useLensPins';

/** Drops ids of Lenses that are not in the loaded list, so a deleted Lens never holds a pin slot. */
export function prunePinnedIds(ids: Array<string>, knownIds: Array<string>): Array<string> {
  const known = new Set(knownIds);
  return ids.filter((id) => known.has(id));
}

/** Pin or unpin across every surface. Only the rail limits how many saved pins it displays. */
export function useLensPinToggle(_knownLensIds?: Array<string>) {
  const [pinnedIds, setPinnedIds, status] = useLensPins();
  const toggle = useCallback(
    (lensId: string) => {
      if (pinnedIds.includes(lensId)) {
        setPinnedIds((current) => current.filter((id) => id !== lensId));
        return;
      }
      setPinnedIds((current) => [...current, lensId]);
    },
    [pinnedIds, setPinnedIds],
  );
  return { isPinned: (lensId: string) => pinnedIds.includes(lensId), pinnedIds, setPinnedIds, ...status, toggle };
}
